import { Pipe, PipeTransform } from '@angular/core';
import { LMFormatUtilService } from '@services/utils/lm-format-util.service'

@Pipe({
  name: 'translate',
  standalone: false
})
export class TranslatePipe implements PipeTransform {

  constructor(private lmFormatUtilService: LMFormatUtilService) {}

  transform(value: string, options?: any): string {
    const translatedText = Soho.Locale.translate(value);
    return options ? this.lmFormatUtilService.formatMessage(translatedText, options) : translatedText;
  }
}
